'use client';

import { c as _c } from "react/compiler-runtime";
import { ChartAllocationHistoryLoading } from '@/components/VaultPage/components/ChartAllocationHistory/states';
import { MarketAllocationLoading } from '../../VaultOverview/MarketAllocation/states';
import { TableReallocateLoading } from '../../VaultRiskCuration/TableReallocate/states';
const VaultAllocationLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="gap-lg sm:gap-xl flex w-full flex-col"><MarketAllocationLoading /><ChartAllocationHistoryLoading /><TableReallocateLoading /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default VaultAllocationLoading;